/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Speed_TitleInputs */

const en_homepage_features_speed_title = /** @type {(inputs: Homepage_Features_Speed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen at 3x speed`)
};

const es_homepage_features_speed_title = /** @type {(inputs: Homepage_Features_Speed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha a velocidad 3x`)
};

/**
* | output |
* | --- |
* | "Listen at 3x speed" |
*
* @param {Homepage_Features_Speed_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_speed_title = /** @type {((inputs?: Homepage_Features_Speed_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Speed_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_speed_title(inputs)
	return en_homepage_features_speed_title(inputs)
});